import {
  CoverageFormOptionType,
  VehicleOptionsResponse,
} from '@clearcover/core-app-types';
import { AddVehicleFormValues } from './VehicleForm';

const getIdentifiers = (
  values: AddVehicleFormValues,
  coverageArray: Array<CoverageFormOptionType>
) => {
  return coverageArray.reduce(
    (acc, coverage) => ({
      ...acc,
      [coverage.identifier]: values.coverages[`${coverage.identifier}`],
    }),
    {}
  );
};
export const buildCreateOrUpdateVehiclePayload = ({
  values,
  type,
  data,
  requiredAccessStatements,
  bypassUnderwriting,
}: {
  values: AddVehicleFormValues;
  type: 'create' | 'update';
  data: VehicleOptionsResponse;
  requiredAccessStatements: boolean;
  bypassUnderwriting?: boolean;
}) => ({
  data: {
    type,
    identifier: values.identifier,
    info: {
      vin: values.vin,
      year: values.year,
      make: values.make,
      model: values.model,
      body: values.body,
    },
    alarmsystem: values.alarmsystem,
    passivedisable: values.passivedisable,
    activedisable: values.activedisable,
    vehiclerecovery: values.vehiclerecovery,
    avgMiles: values.avgMiles,
    rideShare: values.rideShare,
    primaryUse: values.primaryUse,
    ownership: {
      ownershipStatus: values.ownershipStatus,
      lienholder: {
        name: values.lienholder?.name,
        addressLine1: values.lienholder?.address1,
        addressLine2: values.lienholder?.address2,
        city: values.lienholder?.city,
        state: values.lienholder?.state,
        zip: values.lienholder?.zip,
      },
    },
    garagingAddress: values.garagingAddress,
    coverages: getIdentifiers(values, data.coverages),
    endorsements: getIdentifiers(values, data.endorsements),
    assignedDrivers: values.assignedDrivers,
    adas: type === 'create' ? values.adas : undefined,
    usageDetails: {
      usedInMexico: values.usageDetails.usedInMexico,
      availableForNonCoveredDrivers:
        values.usageDetails.availableForNonCoveredDrivers,
      feeBasedServices: values.usageDetails.feeBasedServices,
      hazmatToolTransport: values.usageDetails.hazmatToolTransport,
      usedAsResidence: values.usageDetails.usedAsResidence,
      emergencyServices: values.usageDetails.emergencyServices,
      unacceptableBusinessUse: values.unacceptableBusinessUse,
    },
    parkingLocationReason: values.parkingLocationReason,
    inStateParkingDuration: values.inStateParkingDuration,
    parkingType: values.parkingType,
    registeredToPolicyholderOrSpouse: values.registeredToPolicyholderOrSpouse,
    hasAntiTheftDevice: values.hasAntiTheftDevice,
    ...(bypassUnderwriting
      ? {
          bypassUnderwriting: true,
        }
      : {}),
    ...(requiredAccessStatements
      ? {
          accessVehicleStatementAccepted: true,
        }
      : {}),
  },
});
